import { ExtendedAreaModels } from '@bpd-library/utilities';
import { FILTER_NAMES } from '@features/properties/components/property-filter';
import { hasFilterUrl } from '@source/utilities/filters/urls';
import { translateItem } from '@source/utilities/hooks';

import { Filters } from './construct-filters';

export const setRentalFilter = async (
    data: ExtendedAreaModels,
    filters: Filters,
    options: { applyDefaultSettings: boolean },
) => {
    const hasRental = !!data.projectPhases.find(({ isRental }) => isRental);
    const hasSale = !!data.projectPhases.find(({ isRental }) => !isRental);

    if (hasRental && hasSale) {
        const rentalLabel = await translateItem('Filters.Rental');
        const buyLabel = await translateItem('Filters.Buy');

        filters[FILTER_NAMES.rental] = {
            expanded: false,
            icon: 'specs-house',
            title: await translateItem('Filters.RentalBuy.label'),
            dropdownLabel: await translateItem('Filters.RentalBuy.dropdownLabel'),
            filterFunctions: {
                constructionNumber: (constructionNumber, filterInput) => {
                    const { projectPhase } = constructionNumber;

                    if (!projectPhase) return false;

                    if (filterInput.value === rentalLabel) return !!projectPhase.isRental;
                    if (filterInput.value === buyLabel) return !projectPhase.isRental;

                    return false;
                },
                propertyType: (propertyType, filterInput) => {
                    const { projectPhase } = propertyType;

                    if (!projectPhase) return false;

                    if (filterInput.value === rentalLabel) return !!projectPhase.isRental;
                    if (filterInput.value === buyLabel) return !projectPhase.isRental;

                    return false;
                },
                projectPhase: (projectPhase, filterInput) => {
                    if (filterInput.value === rentalLabel) return !!projectPhase.isRental;
                    if (filterInput.value === buyLabel) return !projectPhase.isRental;

                    return false;
                },
            },
            filterName: FILTER_NAMES.rental,
            hasRangeValues: false,
            filters: {
                type: 'checkbox',
                components: [
                    {
                        id: `${FILTER_NAMES.rental}-${rentalLabel}`,
                        label: rentalLabel,
                        value: rentalLabel,
                        name: FILTER_NAMES.rental,
                        checked: options.applyDefaultSettings
                            ? true
                            : hasFilterUrl(rentalLabel, FILTER_NAMES.rental),
                        type: 'checkbox',
                    },
                    {
                        id: `${FILTER_NAMES.rental}-${buyLabel}`,
                        label: buyLabel,
                        value: buyLabel,
                        name: FILTER_NAMES.rental,
                        checked: options.applyDefaultSettings
                            ? true
                            : hasFilterUrl(buyLabel, FILTER_NAMES.rental),
                        type: 'checkbox',
                    },
                ],
            },
        };
    }
};
